// extracted by mini-css-extract-plugin
module.exports = {"container":"_3cHK0a8IRyo37H0h9PD10R primaryBackgroundColor importantMessageTopBar","inner":"_2jpNLNoZIJRrdPwZ9sIORW"};